import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { login } from "../api";
import { nextRouteFor } from "../lib/postLogin";
import { IconLoader2 } from "@tabler/icons-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils/cn";
import { apiErrorMessage } from "@/lib/http";
import { isMockEnabled } from "@/lib/mock-flags";

export function LoginForm() {
  const isMock = isMockEnabled("auth");
  const [email, setEmail] = useState(isMock ? "dono@imobiliaria.com.br" : "");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const session = await login(email, isMock ? "demo-password" : password);
      setSession(session);
      navigate(nextRouteFor(session.user), { replace: true });
    } catch (error) {
      toast.error(apiErrorMessage(error, "E-mail ou senha inválidos."));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleLogin} className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium text-ink-muted">E-mail</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isMock}
          placeholder="dono@imobiliaria.com.br"
          className="w-full rounded-xl border border-border bg-gray-50 px-4 py-3 text-sm outline-none transition-all focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10"
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-ink-muted">Senha</label>
        <input
          type="password"
          required={!isMock}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={isMock}
          placeholder="••••••••"
          className="w-full rounded-xl border border-border bg-gray-50 px-4 py-3 text-sm outline-none transition-all focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10"
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className={cn(
          "flex w-full items-center justify-center gap-2 rounded-xl bg-brand-grad py-3.5 text-sm font-bold text-white shadow-glow transition-all hover:scale-[1.01] hover:shadow-argon-hover active:scale-[0.99] disabled:opacity-70",
          isLoading && "cursor-not-allowed opacity-70"
        )}
      >
        {isLoading ? (
          <IconLoader2 className="animate-spin" size={18} />
        ) : (
          "Entrar no Portal"
        )}
      </button>
    </form>
  );
}
